import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, useAuth } from 'hooks';
import { LabBillingType, LabVendor } from '../../types';

type Payload = {
  userId: string;
  // Each chosen test as id and name. All tests go on the one lab order, and the
  // backend appends the names to build Healthie's `lab` value (ENG-294).
  labOptions: { id: number; name: string }[];
  billingType: LabBillingType;
  // The lab company the order goes to, same as the chosen vendor.
  labCompany: LabVendor;
};

const useCreateLabOrder = () => {
  const queryClient = useQueryClient();
  const { api } = useApi({ throwIfError: true });
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async ({
      userId,
      labOptions,
      billingType,
      labCompany,
    }: Payload) => {
      return await api({
        route: `/private/dashboard/user/${userId}/lab-order`,
        method: 'POST',
        token: userToken,
        payload: {
          lab_options: labOptions,
          billing_type: billingType,
          lab_company: labCompany,
        },
      });
    },
    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({
        queryKey: ['hc-user-labs', userToken, userId],
      });
    },
  });

  return { mutation };
};

export default useCreateLabOrder;
